import React, {useState} from "react";
import "./PinVerification.scss";
import {MDBBox, MDBIcon, MDBModal, MDBModalBody} from "mdbreact";
import {numberFormat} from "../../util";
import {setForgetPin} from "../../Actions";
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux'
import {Zoom} from "react-reveal"
import {assetUrl} from "../../serviceApi";
import Login from "../../pages/Login/Login";

const Phone = assetUrl+"images/login-mobile.png";
const Lock = assetUrl+"images/lock.svg";
const Coin = assetUrl+"images/left-view-coin.png";
const ArrowLeftIcon = assetUrl+"images/blue-arrow-left.svg";
const CloseIcon = assetUrl+"images/close-icon-grey.png";
const eye = assetUrl+'images/eye_open.svg'
const eyelash = assetUrl+'images/eyeClose.svg'
const RedDots = assetUrl+"images/red-dots-large.png";
const bg = assetUrl+'images/pin-verification-bg.png'



function PinVerification(props){
    const [show_password,setShowPassword] = useState(false);
    const [login_modal, setLoginModal] = useState(false);

   const togglePassword = () => {
       setShowPassword(!show_password);
    }
    const forgetPinRedirection=()=>{
       props.setForgetPin(true)
        openLoginModal();
    }
    const openLoginModal = () => {
        setLoginModal(true);
    }
    const closeLoginModal = () => {
        setLoginModal(false);
    }
    const completeLogin = () => {
        closeLoginModal();
        window.location.reload();
        // this.getWalletData();
    }


    const {pin,handlePinInputChange,submit,selected_action,stock_data,quantity,order_mode,limit_order_price,isOpen,closeModal}= props;
    return(
        <>
            <div
                className={`pin-verification-modal-component`}
            >
                <MDBModal isOpen={isOpen} toggle={closeModal} fullHeight position="bottom">
                    <MDBModalBody>
                        <div className={"d-flex justify-content-between align-items-start custom-modal-header"}>
                            <img src={ArrowLeftIcon} alt={"ArrowLeftIcon"} onClick={closeModal}/>
                            <img src={CloseIcon} alt={"CloseIcon"} onClick={closeModal}  />
                        </div>
                        <div className={"pin-verification-component d-flex flex-column justify-content-between"}>
                            <div>
                                <p className={"description"}>You are {selected_action==="sell"?"selling":"buying"} shares worth</p>
                                <div className={"d-flex align-items-center"}>
                                    {
                                        order_mode === "Limit_Order" ?
                                            <p className={"sell-or-buy-amount "}> {numberFormat((quantity * limit_order_price).toFixed(2))}</p>
                                            :
                                            <p className={"sell-or-buy-amount "}>{numberFormat((quantity * stock_data.price).toFixed(2))}</p>

                                    }
                                    <img src={Coin} alt={"Coin"} className={"img-fluid coin-image"}/>
                                </div>
                                <MDBBox className={'elipse-section'}>
                                    <div className={"phone-img"}><img src={Phone} alt={"altImage"} width={"70%"} /></div>
                                    <div className={"lock-img animate__animated animate__zoomIn delay-3s"}><Zoom delay={500}><img src={Lock} alt={"altImage"} width={"70%"} /></Zoom></div>
                                        <div className={"red-dot-icon animate__animated animate__zoomIn delay-3s"}><Zoom delay={800}><img src={RedDots} alt={"altImage"} /></Zoom></div>
                                        <div className={"bg-circle-icon animate__animated animate__zoomIn delay-3s"}><Zoom delay={500}><img src={bg} alt={"altImage"} width={"85%"} /></Zoom></div>


                                </MDBBox>

                                <form>
                                    <label htmlFor="defaultFormLoginPasswordEx">
                                        Enter your pin
                                    </label>
                                    <div className={"password-input-section"}>
                                        {
                                            show_password === true &&
                                            <input type={"number"}
                                                   pattern="[0-9]*"
                                                   maxLength="4"
                                                   inputMode="numeric"
                                                   id="defaultFormLoginPasswordEx"
                                                   className="form-control"
                                                   value={pin}
                                                   onChange={(e) => handlePinInputChange(e)}
                                                   onInput={(e) => handlePinInputChange(e)}
                                            />
                                        }
                                        {
                                            show_password === false &&
                                                <input type={"password"}
                                                       pattern="[0-9]*"
                                                       maxLength="4"
                                                       inputMode="numeric"
                                                       id="defaultFormLoginPasswordEx"
                                                       className="form-control"
                                                       value={pin}
                                                       onChange={(e) => handlePinInputChange(e)}
                                                       onInput={(e) => handlePinInputChange(e)}
                                                />
                                        }


                                        <img alt={'alt'} src={show_password === true?eye:eyelash} className={"eye-icon"} onClick={togglePassword} />

                                    </div>
                                </form>
                                <div className={"forgot-pin d-flex justify-content-end"} >
                                    <a onClick={()=>forgetPinRedirection()}>Forgot pin?</a>
                                </div>

                            </div>
                            <div className={"fixed-submit-btn"}>
                                <button type={"button"} className={"btn submit-btn"} onClick={submit}>
                                    {
                                        order_mode === "Market_Order" && selected_action==="sell" && "Sell Now"
                                    }
                                    {
                                        order_mode === "Limit_Order" && selected_action==="sell" && "Place Sell Order"
                                    }
                                    {
                                        order_mode === "Market_Order" && selected_action==="buy" && "Buy Now"
                                    }
                                    {
                                        order_mode === "Limit_Order" && selected_action==="buy" && "Place Buy Order"
                                    }
                                    <MDBIcon icon="angle-right" className={"ml-2"} />
                                </button>
                            </div>

            </div>
                    </MDBModalBody>
                </MDBModal>
            </div>
            <Login isOpen={login_modal}
                   closeModal={closeLoginModal}
                   completeLogin={completeLogin}
            />
        </>
    );
}
const mapStateToProps = state => ({
    user_details: state.UserReducer.user_details,
    logged_in: state.UserReducer.logged_in
});
const mapDispatchToProps = dispatch => ({
    setForgetPin: data => dispatch(setForgetPin(data))
})


export default connect(mapStateToProps,mapDispatchToProps)(withRouter(PinVerification));



